<template>
  <a-spin :spinning="spinning">
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form :form="form" layout="inline">

        <a-row :gutter="24">
          <a-col :md="8" :sm="24">
            <a-form-item label="单据编号">
              <a-input
                autocomplete="false"
                v-decorator="[
                'billNo',
                {initialValue:formdata.billNo, rules: [{ required: true, message: '请输入单据编号' }]}
                ]"
              ></a-input>
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <a-form-item
              label="供应商"
              required
            >
              <a-input-search
                placeholder="请选择供应商"
                @change="supplierTextChange"
                @search="onSupplierSelect"
                @click="onSupplierSelect"
                v-model="formdata.supplierName"
              />
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <a-form-item label="单据日期" required>
              <a-date-picker v-model="formdata.billDate" :format="format"></a-date-picker>
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" @click="formSave" :loading="state.btn" :disabled="state.btn">{{saveBtnText}}</a-button>
              <a-button style="margin-left: 8px" @click="toList">历史单据</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <a-divider />
    <div>
      <a-alert type="info" showIcon style="margin-bottom: 10px">
        <span slot="message">
          <span>总数量：{{totalQty}}</span>
          <span style="margin-left: 30px">总金额：{{totalAmount}}</span>
        </span>
      </a-alert>
      <a-table
        bordered
        :dataSource="entries"
        :columns="columns"
        :pagination="false"
        rowKey="id"
        size="middle"
      >
        <div slot="rowIndex" slot-scope="text, record, index">
          <div class="actionIco">
            <a-icon type="plus-square" theme="twoTone" twoToneColor="#52c41a" style="font-size: 16px;cursor: pointer;position: absolute;top: -16px;left: 10px" @click="addRow(index)"/>
            <div></div>
            <a-icon type="minus-square" theme="twoTone" twoToneColor="#f5222d" style="font-size: 16px;cursor: pointer;position: absolute;top: 2px;left: 10px" @click="delRow(record.id)"/>
          </div>
          <div class="rowIndex">
            {{index +1}}
          </div>
        </div>
        <span slot="goods" slot-scope="text, record, index">
          <EntriesGoods :storeList="storeList" :goodsName="record.goodsName" :goodsId="record.goodsId" :rowindex="index" @inputChange="GoodsInputChange"></EntriesGoods>
        </span>
        <span slot="store" slot-scope="text, record, index">
          <EntriesStore
            :goodsId="record.goodsId"
            :storeName="record.storeName"
            :storeId="record.storeId"
            :rowindex="index"
            :storeList="storeList"
            @inputChange="storeInputChange"
          ></EntriesStore>
        </span>
        <span slot="qty" slot-scope="text, record, index">
          <EntriesQty :goodsId="record.goodsId" :value="record.qty" :rowindex="index" @inputChange="qtyInputChange"></EntriesQty>
        </span>
        <span slot="price" slot-scope="text, record, index">
          <EntriesPrice :goodsId="record.goodsId" :value="record.price" :rowindex="index" @inputChange="priceInputChange"></EntriesPrice>
        </span>
        <span slot="amount" slot-scope="text, record, index">
          <EntriesAmount :price="record.price" :qty="record.qty" :rowindex="index"></EntriesAmount>
        </span>
        <span slot="note" slot-scope="text, record, index">
          <EntriesNote :goodsId="record.goodsId" :value="record.note" :rowindex="index" @inputChange="noteInputChange"></EntriesNote>
        </span>
      </a-table>
    </div>
    <div style="margin-top: 15px">
      <a-textarea placeholder="暂无备注信息" :autosize="{ minRows: 2, maxRows: 6 }" v-model="formdata.note" />
    </div>

    <SupplierModal :visible="state.supplierModal" @handleCancel="supplierModalCancel" @handleOk="supplierModalOk"></SupplierModal>
  </a-card>
  </a-spin>
</template>
<script>
import moment from 'moment'

import SupplierModal from '@/components/Supplier/Modal'
import EntriesQty from '@/components/Entries/Edit/Qty'
import EntriesPrice from '@/components/Entries/Edit/Price'
import EntriesAmount from '@/components/Entries/Edit/Amount'
import EntriesStore from '@/components/Entries/Edit/Store'
import EntriesGoods from '@/components/Entries/Edit/Goods'
import EntriesNote from '@/components/Entries/Edit/Note'
import { commonStoreList } from '@/api/common'
import { addPurchaseInvoice, getPurchaseBillDetail } from '@/api/bill'
import { decimal } from '@/utils/util'
import { STATUS_ACTIVE, TYPE_PURCHASE_BILL_IN, CODE_FAIL } from '@/store/mutation-types'
const defaultFormData = {
  billNo: '',
  supplierName: '',
  contactId: '',
  billDate: moment(),
  note: ''
}
const entrieData = {
  id: '',
  goodsId: '',
  goodsName: '',
  storeName: '',
  storeId: '',
  qty: '',
  price: '',
  unitName: '',
  note: '',
  srcOrderEntryId: '',
  srcOrderId: '',
  srcOrderNo: ''
}
export default {
  components: {
    SupplierModal,
    EntriesQty,
    EntriesPrice,
    EntriesAmount,
    EntriesStore,
    EntriesGoods,
    EntriesNote
  },
  data () {
    return {
      spinning: true,
      totalQty: 0,
      totalAmount: 0,
      saveBtnText: '生成购货单',
      columns: [
        {
          title: '#',
          dataIndex: 'rowIndex',
          className: 'text-center',
          scopedSlots: { customRender: 'rowIndex' },
          width: 50
        },
        {
          title: '商品',
          dataIndex: 'goodsName',
          className: 'text-center',
          scopedSlots: { customRender: 'goods' },
          width: 200
        },
        {
          title: '单位',
          dataIndex: 'unitName',
          className: 'text-center',
          width: 50
        },
        {
          title: '仓库',
          dataIndex: 'storeName',
          className: 'text-center',
          width: 130,
          scopedSlots: { customRender: 'store' }
        },
        {
          title: '数量',
          dataIndex: 'qty',
          className: 'text-center',
          width: 75,
          scopedSlots: { customRender: 'qty' }
        },
        {
          title: '购货单价',
          dataIndex: 'price',
          className: 'text-center',
          width: 75,
          scopedSlots: { customRender: 'price' }
        },
        {
          title: '购货金额',
          dataIndex: 'amount',
          className: 'text-center',
          width: 75,
          scopedSlots: { customRender: 'amount' }
        },
        {
          title: '备注',
          dataIndex: 'note',
          className: 'text-center',
          width: 155,
          scopedSlots: { customRender: 'note' }
        },
        {
          title: '关联购货订单号',
          dataIndex: 'srcOrderNo',
          className: 'text-center',
          width: 100
        }
      ],
      form: this.$form.createForm(this),
      format: 'YYYY-MM-DD',
      formdata: {},
      state: {
        btn: false,
        supplierModal: false
      },
      entries: [
      ],
      storeList: null
    }
  },
  methods: {

    buildBillNo () {
      return 'GHD' + moment().format('YYYYMMDDHHmmss')
    },
    supplierTextChange (e) {
      if (!e.data) {
        this.formdata.contactId = ''
      }
    },
    supplierModalCancel () {
      this.state.supplierModal = false
    },
    supplierModalOk (selectedRows) {
      this.state.supplierModal = false
      if (selectedRows.length > 0) {
        const rowData = selectedRows.pop()
        this.formdata.contactId = rowData.id
        this.formdata.supplierName = rowData.name
      }
    },
    onSupplierSelect () {
      this.state.supplierModal = true
    },
    formSave (e) {
      e.preventDefault()
      this.state.btn = true
      this.form.validateFields((err, values) => {
        if (!err) {
          // 判断供应商
          if (!this.formdata.contactId) {
            this.$message.error('请选择供应商')
            this.state.btn = false
            return false
          }
          const saveData = Object.assign({}, values)
          saveData.contactId = this.formdata.contactId
          saveData.billDate = moment(this.formdata.billDate).format(this.format)
          saveData.note = this.formdata.note
          let entries = [...this.entries]
          entries = entries.filter((item) => { return item.goodsId })
          if (entries.length <= 0) {
            this.$message.error('商品信息不能为空')
            this.state.btn = false
            return false
          }
          saveData.entries = entries
          console.log('提交的数据', saveData)
          // 数据提交
          addPurchaseInvoice(saveData).then(res => {
            if (res.status !== CODE_FAIL) {
              this.$message.success('生成购货单成功!')
              this.$router.push({ path: '/purchase/invoice/list' })
            } else {
              this.$message.error(res.message)
            }
          }).catch(() => {
          }).finally(() => {
            this.state.btn = false
          })
        }
      })
    },
    addRow (index) {
      const uuid = this.createUuid()
      const data = Object.assign({}, entrieData, { id: uuid })
      this.entries.splice(index, 0, data)
    },
    delRow (id) {
      const dataSource = [...this.entries]
      if (dataSource.length === 1) {
        this.$message.error('至少保留一条分录')
        return
      }
      this.entries = dataSource.filter(item => item.id !== id)
    },
    createUuid () {
      return 'UUID' + (Math.ceil(Math.random() * 100)) + moment().format('YYYYMMDDHHmmss') + (Math.ceil(Math.random() * 1000))
    },

    initentries () {
      const len = this.entries.length
      if (len < 5) {
        for (let i = 1; i <= (5 - len); i++) {
          this.addRow(len)
        }
      }
    },
    // 数量变化
    qtyInputChange (data) {
      this.entries[data.rowindex].qty = data.value
    },
    // 单价变化
    priceInputChange (data) {
      this.entries[data.rowindex].price = data.value
    },
    loadStore () {
      commonStoreList({ status: STATUS_ACTIVE, all: true })
        .then(res => {
          this.storeList = res.result.data
        })
    },
    // 仓库变化
    storeInputChange (data) {
      this.entries[data.rowindex].storeId = data.value
    },
    // 商品变化
    GoodsInputChange (data) {
      if (this.entries.hasOwnProperty(data.rowindex) === false) {
        this.addRow(data.rowindex)
      }
      this.entries[data.rowindex].goodsName = data.value.goodsName
      this.entries[data.rowindex].goodsId = data.value.id
      this.entries[data.rowindex].storeId = data.value.defaultStoreId
      this.entries[data.rowindex].unitName = data.value.unit.name
      this.entries[data.rowindex].qty = '1'
      this.entries[data.rowindex].price = '0.0000'
      this.entries[data.rowindex].srcOrderEntryId = ''
      this.entries[data.rowindex].srcOrderId = ''
      this.entries[data.rowindex].srcOrderNo = ''
    },
    // 备注变化
    noteInputChange (data) {
      this.entries[data.rowindex].note = data.value
    },
    toList () {
      this.$router.push({ name: 'PurchaseInvoiceList' })
    }
  },
  created () {
    const _this = this
    console.log('是否有参数', this.$route.query)
    const query = this.$route.query
    this.formdata = Object.assign({}, defaultFormData)
    this.formdata.billNo = this.buildBillNo()
    if (query.hasOwnProperty('srcbillid')) {
      getPurchaseBillDetail({ id: query.srcbillid, transType: TYPE_PURCHASE_BILL_IN }).then((res) => {
        if (res.status !== CODE_FAIL) {
          const result = res.result
          console.log(result)
          this.formdata.supplierName = result.supplier.name
          this.formdata.contactId = result.supplier.id
          result.entries.forEach(function (item) {
            if (item.lastQty > 0) {
              const row = {
                id: _this.createUuid(),
                goodsId: item.goodsId,
                goodsName: item.goods.name,
                storeName: item.store.name,
                storeId: item.storeId,
                qty: item.lastQty,
                price: item.price,
                unitName: item.unit.name,
                note: item.note,
                srcOrderEntryId: item.id,
                srcOrderId: query.srcbillid,
                srcOrderNo: result.billNo
              }
              _this.entries.push(row)
            }
          })
          this.initentries()
        } else {
          this.$router.push({ name: 'PurchaseInvoice' })
        }
      }).catch(() => {
      }).finally(() => {
        this.spinning = false
      })
    } else {
      this.initentries()
    }
    this.loadStore()
    this.spinning = false
  },
  watch: {
    'entries': {
      handler: function () {
        const entries = [...this.entries]
        const vm = this
        vm.totalQty = 0
        vm.totalAmount = 0
        entries.forEach(function (item, index, array) {
          if (item.goodsId) {
            const totalAmount = Number(item.qty) * Number(item.price)
            vm.totalQty += Number(item.qty)
            vm.totalAmount += decimal(totalAmount, 4)
          }
        })
      },
      deep: true
    }
  }

}
</script>

<style>
  td {
    height: 48px!important;
    min-height: 48px!important;
  }
  th.text-right, td.text-right {
    text-align: right !important;
  }
  th.text-center, td.text-center {
    text-align: center !important;
  }
  .ant-table .actionIco {
    position: relative;
  }
  .ant-table .rowIndex {
    display: block;
  }
  .ant-table .actionIco {
    display: none;
  }
  .ant-table tr:hover .actionIco {
    display: block;
  }
  .ant-table tr:hover .rowIndex {
    display: none;
  }
  .ant-table-footer {
    padding: 0;
  }
  .ant-table-footer:before {
    height: 0!important;
  }
  .ant-divider-horizontal {
    margin: 0 0 10px;
  }
</style>
